const baseUrl = window.location.origin;
var config = {
	channel: "",
	server: "",
	protocol: "",
	id_asset: 0,
	id_contract: 0,
	type: "",
	ambiente: "DESENVOLVIMENTO" | "PRODUCAO",
	ddsUrl: "",
	version: "",
	sentryKey: "",
	sentryProjectId: "",
	access_type: "",
	tsTokenRedirect: "",
	loginSuccessRedirect: "/carregando-portal",
	daysToExpireTrial: 7,
	educaRedirect: "portal-educa.trademap.com.br",
	enableCaptcha: false,
	siteKeyTurnstile: "",
	siteKeyRecaptcha: "",
	apiKeyAdjust: "",
	apiTokenAdjust: "",
	apiTokenZendesk: "",
};

window.fetch(baseUrl + "/environments.json", { method: "get" }).then((response) => {
	response.json().then((resp) => {
		window["version"] = resp.TAG;
		config.version = resp.TAG;
		config.id_asset = resp.ID_ASSET;
		config.channel = resp.CHANNEL;
		config.server = resp.ADDRESS ? resp.ADDRESS : window.location.host;
		config.protocol = resp.PROTOCOL;
		config.id_contract = resp.CONTRACT;
		config.type = resp.TYPE;
		config.ambiente = resp.AMBIENTE;
		config.ddsUrl = resp.DDS_URL;
		config.tsTokenRedirect = resp.TS_TOKEN_REDIRECT || "";
		config.sentryKey = resp.SENTRY_KEY || "";
		config.sentryProjectId = resp.SENTRY_PROJECT_ID || "";
		config.access_type = resp.ACCESS_TYPE || "PORTAL";
		config.educaRedirect = resp.EDUCA_REDIRECT;
		config.enableCaptcha = String(resp.ENV_ENABLE_CAPTCHA).toLowerCase() === "true";
		config.siteKeyTurnstile = resp.ENV_SITE_KEY_TURNSTILE || resp.SITE_KEY_TURNSTILE;
		config.siteKeyRecaptcha = resp.ENV_SITE_KEY_RECAPTCHA;
		config.apiKeyAdjust = resp.ENV_API_KEY_ADJUST;
		config.apiTokenAdjust = resp.ENV_API_TOKEN_ADJUST;
		config.apiTokenZendesk = resp.ENV_API_TOKEN_ZENDESK;
		localStorage.setItem("CDN_URL", resp.CDN_URL + resp.TAG + "/");
		sessionStorage.setItem("Environment", config.ambiente === "PRODUCAO");
	});
});

export default config;
